import { ISubscriptionPlan } from "../resources/interfaces";
import { User } from "./User"

class SubscriptionPlan {
    id: number;
    companyType: string;
    planCode: string;
    name: string;
    description: string;
    tagline: string;
    planTier: string;
    billingCycle: string;
    planStatus: string;
    displayOrder: number;
    basePrice: number;
    setupFee: number;
    currency: string;
    discountPercentage: number;
    finalPrice: number;
    hasTrial: boolean;
    trialDays: number;
    trialRequiresCard: boolean;
    maxMotorPolicies: number;
    maxNonMotorPolicies: number;
    maxUsers: number;
    maxBranches: number;
    maxStorageGb: number;
    maxApiCalls: number;
    unlimitedPolicies: boolean;
    products: null;
    hasAnalytics: boolean;
    hasAdvancedReports: boolean;
    hasApiAccess: boolean;
    hasWhiteLabel: boolean;
    hasCustomIntegrations: boolean;
    hasAccountManager: boolean;
    hasPrioritySupport: boolean;
    has24x7Support: boolean;
    supportResponseHours: number;
    customFeatures: string;
    terms: string;
    internalNotes: string;
    createdOn: string;
    updatedOn: string;
    createdBy: User;
    updatedBy: User;
    availableFrom: string;
    availableUntil: string;
    active: boolean;
    public: boolean;
    featured: boolean;
    totalInitialCost: number;
    totalPolicyLimit: number;
    available: boolean;

    constructor(subscriptionPlan: ISubscriptionPlan) {
        this.id = subscriptionPlan.id;
        this.planCode = subscriptionPlan.planCode;
        this.name = subscriptionPlan.name;
        this.description = subscriptionPlan.description;
        this.tagline = subscriptionPlan.tagline;
        this.planTier = subscriptionPlan.planTier;
        this.billingCycle = subscriptionPlan.billingCycle;
        this.planStatus = subscriptionPlan.planStatus;
        this.displayOrder = subscriptionPlan.displayOrder;
        this.basePrice = subscriptionPlan.basePrice;
        this.setupFee = subscriptionPlan.setupFee;
        this.currency = subscriptionPlan.currency;
        this.discountPercentage = subscriptionPlan.discountPercentage;
        this.finalPrice = subscriptionPlan.finalPrice;
        this.hasTrial = subscriptionPlan.hasTrial;
        this.trialDays = subscriptionPlan.trialDays;
        this.trialRequiresCard = subscriptionPlan.trialRequiresCard;
        this.maxMotorPolicies = subscriptionPlan.maxMotorPolicies;
        this.maxNonMotorPolicies = subscriptionPlan.maxNonMotorPolicies;
        this.maxUsers = subscriptionPlan.maxUsers;
        this.maxBranches = subscriptionPlan.maxBranches;
        this.maxStorageGb = subscriptionPlan.maxStorageGb;
        this.maxApiCalls = subscriptionPlan.maxApiCalls;
        this.unlimitedPolicies = subscriptionPlan.unlimitedPolicies;
        this.products = subscriptionPlan.products;
        this.hasAnalytics = subscriptionPlan.hasAnalytics;
        this.hasAdvancedReports = subscriptionPlan.hasAdvancedReports;
        this.hasApiAccess = subscriptionPlan.hasApiAccess;
        this.hasWhiteLabel = subscriptionPlan.hasWhiteLabel;
        this.hasCustomIntegrations = subscriptionPlan.hasCustomIntegrations;
        this.hasAccountManager = subscriptionPlan.hasAccountManager;
        this.hasPrioritySupport = subscriptionPlan.hasPrioritySupport;
        this.has24x7Support = subscriptionPlan.has24x7Support;
        this.supportResponseHours = subscriptionPlan.supportResponseHours;
        this.customFeatures = subscriptionPlan.customFeatures;
        this.terms = subscriptionPlan.terms;
        this.internalNotes = subscriptionPlan.internalNotes;
        this.createdOn = subscriptionPlan.createdOn;
        this.updatedOn = subscriptionPlan.updatedOn;
        this.createdBy = subscriptionPlan.createdBy;
        this.updatedBy = subscriptionPlan.updatedBy;
        this.availableFrom = subscriptionPlan.availableFrom;
        this.availableUntil = subscriptionPlan.availableUntil;
        this.active = subscriptionPlan.active;
        this.public = subscriptionPlan.public;
        this.featured = subscriptionPlan.featured;
        this.totalInitialCost = subscriptionPlan.totalInitialCost;
        this.totalPolicyLimit = subscriptionPlan.totalPolicyLimit;
        this.available = subscriptionPlan.available;
        this.companyType = subscriptionPlan.companyType;
    }
}

export default SubscriptionPlan;
